var AppConstants = require('../constants/AppConstants');
var AppDispatcher = require('../dispatcher/AppDispatcher');

var ActionTypes = AppConstants.ActionTypes;

var TranslationsAction = {
  getTranslations: function(countryCode, localeId) {
    var action = {
        type: ActionTypes.GET_TRANSLATIONS,
        countryCode: countryCode,
        localeId: localeId
    };
    AppDispatcher.dispatch(action);
  }
}

module.exports = TranslationsAction;